export default __webpack_public_path__ + "static/media/blow.30b41445.jpg";